import { createContext } from 'react';

export const SidebarMenuContext = createContext({
  active: false,
  hasSubMenu: false,
  setHasSubMenu: (hasSubMenu: boolean) => { hasSubMenu; },
});
